export default __webpack_public_path__ + "static/media/steam.a9017411.png";